module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.aa01324f.woff2";